import React, { useEffect } from 'react';
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useSelector } from "react-redux"; 
import Config from "../Config";

const useCartActions = () => {
    const queryClient = useQueryClient();
    const user = useSelector((state) => state.UserReducer.user);

    const apiCall = async ({ method = "post", endpoint, payload }) => {
        // This check now uses the most up-to-date user object from the Redux store.
        if (!user?.token) {
            console.error("API call failed: No user token found in Redux state.", user);
            throw new Error("Authentication token not found.");
        }

        const config = {
            method,
            url: `${Config.apiUrl}/cart/${endpoint}`,
            headers: { Authorization: `Bearer ${user.token}` },
            data: payload,
        };
        const { data } = await axios(config);
        return data;
    };

    const mutationOptions = {
        onSuccess: () => {
            queryClient.invalidateQueries(['cart', user?.token]);
        },
        onError: (error) => {
            console.error("Cart action failed:", error.message);
        },
    };

    // Mutations remain the same
    const addItem = useMutation((newItem) => apiCall({ endpoint: "add", payload: newItem }), mutationOptions);
    const updateItem = useMutation((itemUpdate) => apiCall({ method: "put", endpoint: `items/${itemUpdate.id}`, payload: { quantity: itemUpdate.quantity } }), mutationOptions);
    const removeItem = useMutation((itemId) => apiCall({ method: "delete", endpoint: `items/${itemId}` }), mutationOptions);

    return { addItem, updateItem, removeItem };
};

export default useCartActions;